"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
require("./linkBar.scss");
const LinkBar = (props) => {
    const { directoryType } = props;
    const active = window.location.href.indexOf(directoryType) > -1 ? 'active' : '';
    return (react_1.default.createElement("div", { className: "link-block" },
        react_1.default.createElement("a", { className: `${active}`, href: `#/directory/${directoryType}` }, directoryType),
        react_1.default.createElement("span", { className: `${active}` })));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        experts
    };
};
const mapDispatchToProps = (dispatch) => {
    return {};
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(LinkBar);
